import { Routes, Route } from "react-router-dom";
import Staffels from "./Staffels";
import { StaffelTabs } from "./utils/StaffelUtils";
import GasolineStaffelCreateEdit from "./GasolineStaffelCreateEdit";
import GasolineStaffelDetails from "./GasolineStaffelDetails";
import FeetStaffelCreateEdit from "./FeetStaffelCreateEdit";
import FeetStaffelDetails from "./FeetStaffelDetails";
import WaterLevelStaffelCreateEdit from "./WaterLevelStaffelCreateEdit";
import WaterLevelStaffelDetails from "./WaterLevelStaffelDetails";
import { useState } from "react";

const index = () => {

	const [ selectedTab, selectTab ] = useState(StaffelTabs.GASOLINE);

	return (
		<Routes>
			<Route index element={<Staffels defaultTab={selectedTab} onTabChange={(tab) => selectTab(tab)} />} />

			<Route path='/create/gasoline' element={<GasolineStaffelCreateEdit />} />
			<Route path='/:id/edit/gasoline' element={<GasolineStaffelCreateEdit />} />
			<Route path='/:id/details/gasoline' element={<GasolineStaffelDetails />} />

			<Route path='/create/feet' element={<FeetStaffelCreateEdit />} />
			<Route path='/:id/edit/feet' element={<FeetStaffelCreateEdit />} />
			<Route path='/:id/details/feet' element={<FeetStaffelDetails />} />

			<Route path='/create/waterlevel' element={<WaterLevelStaffelCreateEdit />} />
			<Route path='/:id/edit/waterlevel' element={<WaterLevelStaffelCreateEdit />} />
			<Route path='/:id/details/waterlevel' element={<WaterLevelStaffelDetails />} />
		</Routes>
	);
};

export default index;
